import React from 'react';
import { Block, FlexRow, Form } from '@guryou/html-components';

const FormContainer = ({ handleSubmit, children, parserVersion = null }) => {
  return (
    <Block lg={5.6} md={5.8} xs={12}>
      <Form margin={0} padding={0} actions={false} onSubmit={handleSubmit} parserVersion={parserVersion}>
        <FlexRow xs={12} justifyContent="center">
          {children}
        </FlexRow>
      </Form>
    </Block>
  );
};

export default FormContainer;
